import * as React from 'react';
import './Call.css';

// import { linkHorizontal } from 'd3'
// import classNames from 'classnames'
// import * as _ from 'lodash'
import {makeBox, boxContains, setVars, parseConstraintTemplate as kfParse, Constraint, tree, Box} from 'kiwifruit'
import {KiwifruitUser, propsFor, styleFor, GetVariable, AddConstraint} from 'kiwifruit-react'
import {NetworkKiwifruitUser} from 'golgi-kiwifruit'


import WithContextMenu, { Menu, MenuItem } from './WithContextMenu'
import CallCodeEditor from './CallCodeEditor'
import SizedBox from './SizedBox'
import Steps from './Steps'

import * as actions from '../actions'

import classNames from 'classnames'
import * as _ from 'lodash'

import { nodeInfo, GraphNodeInfo } from '../model/nodeInfo'
import { NetworkUser } from 'golgi'
import * as Model from '../types/document'
import { Cursor, CursorV } from '../lib/Cursor';
import { Stack } from '../types/stack';
import { documentC, debugMode } from '../globals';
import { inputLabelsForCodeCall, InputLabel } from '../model/inputLabelsForCodeCall'
import NewInputDropSite from 'src/view/NewInputDropSite';
import NodeToken from 'src/view/NodeToken';
import ExpansionTrapezoid from 'src/view/ExpansionTrapezoid';
import { evaluateNode } from 'src/model/evaluate';

const {weak} = Constraint

const minimumLabelSize = 40

export const arrowSize = 10

class Call extends React.Component<{
  callC: Cursor<Model.Call>,
  graphC: Cursor<Model.Graph>,
  blockC: Cursor<Model.Block>,
  stack: Stack,
  callBox: Box,
  inputBoxes: Array<Box>,
  outputBox: Box,
  expanded: boolean,
  setExpanded: (expanded: boolean) => void,
  activeIndex: number | string,
}> {
  render() {
    return <NetworkKiwifruitUser debugName="Call" props={this.props} state={this.state} render={({ getVariable, addConstraint, id }) => {
      const {callC, graphC, blockC, stack,
        callBox, inputBoxes, outputBox} = this.props
      let {activeIndex} = this.props
      const {expanded, setExpanded} = this.props
      const call = callC.get()
      // const id = JSON.stringify(stack) + call.id

      // fix activeIndex...
      if (call.callType === 'list-op' && activeIndex === 0) {
        const inputResult = evaluateNode(call.inputs[0].outside, stack)
        if (inputResult.type === 'value' && !(inputResult.value instanceof Array)) {
          activeIndex = _.keys(inputResult.value)[0]
        }
      }

      // Horizontal spacing
      addConstraint(...
        tree.row({name: id + 'input-call-output-row', spacing: 20, shrink: 'h'},
          tree.box({name: id + 'inputs'},
            inputBoxes
          ),
          tree.box({box: callBox, shrink: 'h'}),
          outputBox
        )
      )

      // Construct the call label and, if needed, the body
      let callLabel = undefined
      let callLabelBox = makeBox(id + '-label', addConstraint)
      addConstraint(kfParse`${callLabelBox.right} == ${callBox.right} - ${arrowSize} - 10`)
      addConstraint(kfParse`${callLabelBox.bottom} == ${outputBox.vMid} - 5`)
      addConstraint(...boxContains(callBox, callLabelBox))
      let callBody = undefined
      let callBodyBox = makeBox(id + '-body', addConstraint)
      let labelEndX = id + '-labelEndX'  // only for labels after the first
      let junctionX = id + '-junctionX'
      addConstraint(...boxContains(callBox, callBodyBox))
      addConstraint(kfParse`${callBodyBox.right} <= ${callBox.right} - ${arrowSize} - 10`)  // strict right margin (could be loose?)
      // addConstraint(kfParse`${callBodyBox.left} >= ${callBox.left} + 10`)
      addConstraint(kfParse`${callBodyBox.top} == ${outputBox.vMid} + 10`)
      if (call.inputs.length > 1) {
        addConstraint(kfParse`${callBodyBox.left} >= ${junctionX} + 20`)
      } else {
        addConstraint(kfParse`${callBodyBox.left} >= ${callBox.left} + 20`)
      }
      addConstraint(kfParse`${labelEndX} + 20 == ${junctionX}`)
      addConstraint(kfParse`${labelEndX} >= ${callBox.left} + ${minimumLabelSize}`)
      addConstraint(weak(kfParse`${labelEndX} == ${callBox.left}`))

      // Kinda a hack for now: make sure the call box is tall enough for the
      // inputs (for svgs)
      addConstraint(kfParse`${callBox.top} <= ${outputBox.top}`)
      if (inputBoxes.length > 0) {
        addConstraint(kfParse`${callBox.bottom} >= ${inputBoxes[inputBoxes.length - 1].bottom}`)
      }

      // BAD MISTAKES:
      // * leaving off "addConstraint" (either at the beginning, or after 'box')
      // * interpolating a number from a getVariable instead of the variable itself (!!!)

      switch (call.callType) {
      case 'code':
        callLabel = (
          <CallCodeEditor callC={callC as Cursor<Model.CodeCall>} graphC={graphC} blockC={blockC} stack={stack}
                          desiredWidth={200} maxFontSize={16} minFontSize={10} />
        )
        break
      case 'definition':
        const calledDefinition = documentC._('definitions').fetch().call(CursorV.selectPattern, {id: call.definition}).value()
        callLabel = (
          <div className="font-definition" style={{whiteSpace: 'nowrap'}}>
            {calledDefinition ? calledDefinition.name : "DEFINITION LOST"}
          </div>
        )
        break
      case 'list-op': {
        callLabel = (
          <div className="font-definition">{call.listOpType}</div>
        )

        const listOpCallC = callC as Cursor<Model.ListOpCall>

        callBody = (
          <div className="Call-body">
            <Steps stepsC={listOpCallC._('block')._('steps')} blockC={listOpCallC._('block')}
                  stack={[...stack, {type: 'list-op', callP: callC.path(), index: activeIndex}]} />
          </div>
        )

        break }
      }

      return (
        <div className="Call">
          <WithContextMenu menuMaker={() => this.callMenu()}>
            {/* Main arrow */}
            <svg className="Call-arrow" {...propsFor.svg(getVariable, callBox)} style={{...styleFor.svg(getVariable, callBox)}}>
              <line x1={getVariable(callBox.left)}              y1={getVariable(outputBox.vMid)}
                    x2={getVariable(callBox.right)}             y2={getVariable(outputBox.vMid)} />
              <line x1={getVariable(callBox.right) - arrowSize} y1={getVariable(outputBox.vMid) - arrowSize}
                    x2={getVariable(callBox.right)}             y2={getVariable(outputBox.vMid)} />
              <line x1={getVariable(callBox.right) - arrowSize} y1={getVariable(outputBox.vMid) + arrowSize}
                    x2={getVariable(callBox.right)}             y2={getVariable(outputBox.vMid)} />
            </svg>
            {/* Inputs */}
            {call.inputs.map(({outside: inputNodeId, inside}, i) =>
              this.renderInput({inputNodeId, inside, i, getVariable, addConstraint, callLabelBox, labelEndX, junctionX, id})
            )}
            {call.inputs.length > 0 &&  // TODO: there should still be a drop site somewhere
              <NewInputDropSite
                x={getVariable(callBox.left)} y={getVariable(outputBox.vMid) - 60}
                width={getVariable(labelEndX) - getVariable(callBox.left)}
                blockC={blockC} callC={callC} graphC={graphC} stack={stack}
                index={0}
              />
            }
            <SizedBox box={callLabelBox}>
              { callLabel }
            </SizedBox>
            <SizedBox box={callBodyBox}>
              { callBody }
            </SizedBox>
            { debugMode &&
              <div style={{position: 'absolute', left: getVariable(callBox.left), top: getVariable(outputBox.vMid) + 5, fontSize: "70%"}}>
                {callC.get().id}
              </div>
            }
            { call.callType === 'definition' &&
              <div className='Call-expansion-button' data-call={call.id} data-stack={btoa(JSON.stringify(stack))}
                   style={{display: 'flex', position: 'absolute', left: getVariable(callBox.right) - arrowSize - 20, top: getVariable(outputBox.vMid) + 5}}>
                <svg width={12} height={12}>
                  <g onClick={() => setExpanded(!expanded)}>
                    <rect x={1} y={1} width={10} height={10}
                          fill="white" stroke="black"/>
                    <line x1={3} y1={6}
                          x2={9} y2={6} />
                    { !expanded &&
                      <line x1={6} y1={3}
                            x2={6} y2={9} />
                    }
                  </g>
                </svg>
              </div>
            }
            { expanded &&
              <ExpansionTrapezoid callId={call.id} stack={stack} />
            }
          </WithContextMenu>
        </div>
      )
    }}/>
  }

  renderInput(info: {inputNodeId: string, inside: string, i: number, getVariable: GetVariable, addConstraint: AddConstraint,
                     callLabelBox: Box, labelEndX: string, junctionX: string, id: string}) {
    const {inputNodeId, inside, i, getVariable, addConstraint, callLabelBox, labelEndX, junctionX, id} = info
    const {callC, graphC, blockC, stack, callBox, inputBoxes, outputBox, activeIndex} = this.props

    const call = callC.get()

    const inputBox = inputBoxes[i]
    const inputBoxVMidNow = getVariable(inputBox.vMid)
    const outputBoxVMidNow = getVariable(outputBox.vMid)
    if (i === 0) {
      addConstraint(kfParse`${inputBox.vMid} == ${outputBox.vMid}`)
    }
    const inputLabelBox = makeBox(id + '-input-' + i, addConstraint)
    addConstraint(...setVars(inputLabelBox, {left: callBox.left}))
    addConstraint(...boxContains(callBox, inputLabelBox))
    addConstraint(kfParse`${inputLabelBox.bottom} == ${inputBox.vMid} - 5`)
    let inputLabel = undefined
    if (call.callType === 'definition') {
      inputLabel =
        <div>
          {nodeInfo(Cursor.selectPattern(documentC._('definitions'), {id: call.definition}), inside).name}
        </div>
    } else if (call.callType === 'list-op') {
      const newStack: Stack = [...stack, {type: 'list-op', callP: callC.path(), index: activeIndex}]
      inputLabel =
        <div style={{whiteSpace: 'nowrap'}}>
          <NodeToken className="font-node" nodeId={call.elementNodeId} blockC={(callC as Cursor<Model.ListOpCall>)._('block')} stack={newStack}>item</NodeToken>
          {' '}
          <NodeToken className="font-node" nodeId={call.indexNodeId} blockC={(callC as Cursor<Model.ListOpCall>)._('block')} stack={newStack}>index</NodeToken>
        </div>
    } else {
      const inputLabels = inputLabelsForCodeCall(callC as Cursor<Model.CodeCall>, blockC)

      const labelInfo = inputLabels[i]
      if (labelInfo.type === 'numbered') {
        inputLabel =
          <div style={{fontFamily: 'monospace'}} >
            {labelInfo.number}
          </div>
      }
    }
    if (i === 0) {
      addConstraint(kfParse`${callLabelBox.left} >= ${inputLabelBox.right} + 20`)
    } else {
      addConstraint(kfParse`${labelEndX} >= ${inputLabelBox.right} + 20`)
    }
    return (
      <div key={inputNodeId} className="Call-input">
        {i > 0 &&
          <svg {...propsFor.svg(getVariable, callBox)} style={styleFor.svg(getVariable, callBox)}>
            <line x1={getVariable(callBox.left)} y1={inputBoxVMidNow} x2={getVariable(labelEndX)} y2={inputBoxVMidNow} />
            <line x1={getVariable(labelEndX)} y1={inputBoxVMidNow} x2={getVariable(junctionX)} y2={outputBoxVMidNow} />
          </svg>
        }
        <WithContextMenu menuMaker={() => this.inputMenu(inputNodeId)}>
          <SizedBox box={inputLabelBox}>
            {inputLabel}
          </SizedBox>
        </WithContextMenu>
        <NewInputDropSite
          x={getVariable(callBox.left)} y={getVariable(inputBox.vMid) + 10}
          width={getVariable(labelEndX) - getVariable(callBox.left)}
          blockC={blockC} callC={callC} graphC={graphC} stack={stack}
          index={i + 1}
        />
      </div>
    )
  }


  inputMenu(inputNodeId: Model.NodeId): Menu {
    const {callC, graphC, blockC} = this.props
    return [
      { type: 'heading', heading: "INPUT" },
      {
        type: 'contents',
        contents: "Delete input",
        onClick: () => actions.act(() => {
          actions.deleteInputFromCall(inputNodeId, callC.get().id, graphC, blockC)
        })
      }
    ]
  }

  callMenu(): Menu { return actions.act((): Menu => {
    const {callC, graphC, blockC} = this.props
    
    const collapsible = (
      callC.get().callType === 'code' &&
      _.every(callC.get().inputs, ({outside}) => {
        const info = nodeInfo(blockC, outside) as GraphNodeInfo
        return !!info.referredNodeId
      })
    )

    let menu: Menu = [
      { type: 'heading', heading: "CODE" },
    ]

    if (collapsible) {
      menu.push({
        type: 'contents',
        contents: "Collapse",
        onClick: () => actions.act(() => {
          actions.collapseCall(callC as Cursor<Model.CodeCall>, graphC, blockC)
        })
      })
    }

    menu.push({
      type: 'contents',
      contents: callC.select('broken').get() ? "Unsplit onto one line" : "Split onto new line",
      onClick: () => actions.act(() => {
        callC.select('broken').update((broken) => !broken)
      })
    })

    return menu
  })}
}

export default Call;



// WEBPACK FOOTER //
// ./src/view/Call.tsx